import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.a `
  ${ButtonReset};

  position: relative;
  display: inline-flex;
  align-items: center;
  color: var(--fgColor, ${brand.base.blue});
  ${fonts.apparat.semiBold}
  font-size: ${fluid(18, 26)};
  line-height: 1em;
  text-decoration: none;

  /* Mobile click styles - button should mimic press */
  @media ${until(Device.TabletLarge)} {
    ${transition('transform')};

    &:active {
      transform: translateY(1.5px);
    }
  }

  & > span {
    position: relative;
  }

  & > span::after {
    ${transition('transform')}

    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    background: var(--fgColor, ${brand.base.blue});
    height: 2px;
    transform: scaleX(0);
    transform-origin: center left;
    width: 100%;
  }

  svg {
    ${transition('transform')}

    display: block;
    color: var(--accentColor, ${brand.primary.orange});
    margin-left: 8px;
    width: 17px;
  }

  &:not(span):focus-visible,
  &:not(span).focus-ring,
  &:not(span):hover {
    & > span::after {
      transform: scaleX(1);
    }
  }

  &:not(span).focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
    outline-color: var(--fgColor, ${brand.base.blue});
  }

  &[data-has-arrow='true']:not(span):focus-visible,
  &[data-has-arrow='true']:not(span):hover {
    svg {
      transform: translateX(${fluid(8, 12)});
    }
  }

  a:focus-visible span&,
  a:hover span&,
  button:focus-visible span&,
  button:hover span& {
    & > span::after {
      transform: scaleX(1);
    }
  }

  a:focus-visible span[data-has-arrow='true']&,
  a:hover span[data-has-arrow='true']&,
  button:focus-visible span[data-has-arrow='true']&,
  button:hover span[data-has-arrow='true']& {
    svg {
      transform: translateX(${fluid(8, 12)});
    }
  }
`;
const CtaLinkStyles = {
    Container,
};
export default CtaLinkStyles;
